import React from 'react';
import styled from 'styled-components';
import { palette } from 'pages/AnyfitMall/theme';

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 300px;
  padding: 2rem 1rem;
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid ${palette.Gray200};
  border-top: 4px solid ${palette.AnyBlue};
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1.5rem;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: bold;
  color: ${palette.Gray900};
  margin-bottom: 0.75rem;
  font-family: 'Noto Sans KR', sans-serif;
`;

const Progress = styled.p`
  font-size: 0.938rem;
  color: ${palette.Gray600};
  font-family: 'Noto Sans KR', sans-serif;
`;

/**
 * 케어센스 공통 로딩 UI
 * 레이아웃 시프트 방지를 위해 고정 높이 사용
 * @param {number} progress - 진행률 (0-100)
 * @param {string} title - 표시할 제목 (기본값: '케어센스 연동 중')
 */
const CaresenseLoading = ({ progress = 0, title = '케어센스 연동 중' }) => {
  return (
    <LoadingContainer>
      <Spinner />
      <Title>{title}</Title>
      <Progress>진행률: {progress}%</Progress>
    </LoadingContainer>
  );
};

export default CaresenseLoading;
